import { PluginDescription, PluginType } from '../types/plugin';

export function extractInitialPluginExtra(plugin: PluginDescription) {
  if (plugin.plugin_type === PluginType.chat_image) {
    const { chat_image_web_settings } = plugin;
    if (!chat_image_web_settings) {
      return {};
    }
    const { picture_style_list } = chat_image_web_settings;
    if (picture_style_list.length === 0) {
      return {};
    }
    return {
      chat_image_plugin_settings: {
        style_name: [picture_style_list[0].avatar_style_name],
      },
    };
  }
  return {};
}
